import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import 'text-security/text-security.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { moduleBrokerName, moduleEnableSubscription } from './module-params';

console.log(`
-----------------------------
📊 BROKER CONFIGURATION
-----------------------------
🔹 Broker Name         : ${moduleBrokerName || ''}
🔹 Subscription Module: ${moduleEnableSubscription ? '✅ Yes' : '❌ No'}
-----------------------------
`);

const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
